import { helpbuttonStyle } from '@bingads-webui-campaign-react/common-styles';
import { getUIBlockerStyle } from './blocker';

export const getAudienceEditorStyle = (_, theme) => {
  const { palette = {} } = theme;
  return {
    '@global': {
      '#apexHelpContainer, .apex-help-container, #apexHelpContainer.apex-help-container': {
        zIndex: '11000000 !important', // Need a z-index higher than the z-index of Fluent UI Panel
      },

      ...getUIBlockerStyle({ palette })['@global'],
    },

    editorContainer: {
      '& .ms-Panel-contentInner': {
        overflowY: 'unset',
      },
      '& .ms-Panel-content': {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        overflowY: 'auto',

        '& .alert-info': {
          margin: '20px 0',

          '& .ms-Icon': {
            fontSize: 16,
            marginRight: 8,
          },
        },

        '& .audience-signal-section:not(:last-child)': {
          borderBottom: `1px solid ${palette.neutralLight}`,
          marginBottom: 16,
          paddingBottom: 16,
        },

        '& .server-errors': {
          marginBottom: 16,
        },

        '& .error': {
          color: '#A80000',
        },

        '& .helpbutton': {
          ...helpbuttonStyle(theme)['.helpbutton'],
          verticalAlign: 'initial',
        },

        '& .helpbutton::before': {
          ...helpbuttonStyle(theme)['.helpbutton::before'],
          verticalAlign: 'initial',
        },
      },

      '& .ms-Panel-footer': {
        backgroundColor: palette.white,
        borderTop: `1px solid ${palette.neutralLight}`,

        '& .audience-editor-buttons': {
          display: 'flex',
          flexDirection: 'row',
          gap: '8px',
        },
      },
    },
  };
};
